var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.47 8.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f66c57;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    className: "cls-1",
    d: "M8.37.53A.79.79,0,0,0,7.62,0H1.84a.79.79,0,0,0-.75.53L0,3.68V7.89a.52.52,0,0,0,.53.52h.52a.52.52,0,0,0,.53-.52V7.36H7.89v.53a.52.52,0,0,0,.52.52h.53a.53.53,0,0,0,.53-.52V3.68ZM1.84,5.78A.79.79,0,1,1,2.63,5h0a.79.79,0,0,1-.79.79Zm5.78,0a.79.79,0,1,1,0-1.57A.78.78,0,0,1,8.41,5h0a.78.78,0,0,1-.78.79ZM1.05,3.15,1.84.79H7.62l.79,2.37Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.fe4c0570.svg";
export { ForwardRef as ReactComponent };